import React, { useState } from "react";
import { Loader2, KeyRound } from "lucide-react";
import { adminChangePassword, formatApiError } from "../../lib/api";
import { useToast } from "../../hooks/use-toast";

export default function ChangePasswordPanel({ forced = false, onDone }) {
  const { toast } = useToast();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) {
      setError("New passwords do not match.");
      return;
    }
    if (next.length < 8) {
      setError("New password must be at least 8 characters.");
      return;
    }
    setLoading(true);
    try {
      await adminChangePassword(current, next);
      toast({ title: "Password updated", description: "Your password has been changed successfully." });
      setCurrent(""); setNext(""); setConfirm("");
      onDone && onDone();
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Could not update password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md">
      {forced && (
        <div className="mb-5 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3">
          For security, please set a new password before continuing.
        </div>
      )}
      <form onSubmit={submit} data-testid="change-password-form" className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm">
        {error && (
          <div data-testid="change-password-error" className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-4 py-3">{error}</div>
        )}
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-heading font-semibold text-homi-black mb-2">Current / temporary password</label>
            <input data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="w-full border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:border-homi-gold" required />
          </div>
          <div>
            <label className="block text-sm font-heading font-semibold text-homi-black mb-2">New password</label>
            <input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} className="w-full border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:border-homi-gold" required />
          </div>
          <div>
            <label className="block text-sm font-heading font-semibold text-homi-black mb-2">Confirm new password</label>
            <input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:border-homi-gold" required />
          </div>
        </div>
        <button data-testid="cp-submit" type="submit" disabled={loading} className="mt-6 inline-flex items-center justify-center gap-2 bg-homi-gold hover:bg-homi-goldDark text-homi-black font-heading font-bold px-6 py-3 rounded-lg transition-colors disabled:opacity-70">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><KeyRound className="w-4 h-4" /> Update Password</>}
        </button>
      </form>
    </div>
  );
}
